import hash from 'object-hash';
import useSWR from 'swr';
import { getHRCalendarEvents, GetHRCalendarEventsFilters } from '../../../providers/api/hr/hrProvider';
import { SWRCustomResponse } from '../../../hooks/types';
import { HRCalendarEvent } from '../../../providers/api/dtos';
import { useMatchMutate } from '../../../utils/swr/swr';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';

const BASE_USE_HR_CALENDAR_EVENTS_RID = 'hr-calendar-events';

export const computeUseHRCalendarEventsRID = (
  filters: GetHRCalendarEventsFilters,
): string[] => [BASE_USE_HR_CALENDAR_EVENTS_RID, hash({ filters })];

export const useHRCalendarEvents = (
  filters?: GetHRCalendarEventsFilters,
  pagination: PaginationParams = {},
): SWRCustomResponse<PaginatedResult<HRCalendarEvent>, Error> => {
  const matchMutate = useMatchMutate();
  const key = filters ? computeUseHRCalendarEventsRID(filters) : null;

  const result = useSWR(key, () => getHRCalendarEvents(filters, pagination));

  return {
    ...result,
    mutate: () => matchMutate(BASE_USE_HR_CALENDAR_EVENTS_RID),
  };
};
